import { ORDER_STATUS } from "@/lib/api";

export function StatusBadge({ status, testId, warning }) {
  const meta = ORDER_STATUS[status] || { label: status, bg: "#E4E4E7", text: "#09090B", border: "#A1A1AA" };
  const bg = warning ? "#DC2626" : meta.bg;
  const color = warning ? "#FFFFFF" : meta.text;
  const border = warning ? "#991B1B" : meta.border;
  const label = warning ? "Geciken Sipariş" : meta.label;

  return (
    <span
      data-testid={testId || `status-${status}`}
      className="px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] border inline-flex items-center"
      style={{ backgroundColor: bg, color, borderColor: border }}
    >
      {label}
    </span>
  );
}

export default StatusBadge;
